import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  connect() {
    this.syncIcon()
  }

  toggle(event) {
    event.preventDefault()
    const isOpen = document.body.classList.toggle("mobile-nav-active")
    this.syncIcon(isOpen)
  }

  closeOnNavLink(event) {
    if (!event.target.closest("a")) return
    if (!document.body.classList.contains("mobile-nav-active")) return

    document.body.classList.remove("mobile-nav-active")
    this.syncIcon(false)
  }

  syncIcon(isOpen = document.body.classList.contains("mobile-nav-active")) {
    if (!this.hasToggleTarget) return

    this.toggleTarget.classList.toggle("bi-list", !isOpen)
    this.toggleTarget.classList.toggle("bi-x", isOpen)
  }
}
